<!--Header-->
<div class="modal-header">
  <div class="modal-title">
    <h4>
      @if (modal_type === "Add") {
        Add New Firearm
      }
      @if (modal_type === "Edit") {
        Edit Firearm
      }
    </h4>
  </div>
  <button type="button" class="close-btn" (click)="closeModalClick()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!--body-->
<div class="modal-body-scroll">
  <form [formGroup]="add_edit_firearm_form" (ngSubmit)="addEditFirearmClick()">
    <!-- Firearm UPC -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="firearm_upc" class="form-label">
        <span class="text-danger me-1">*</span>Firearm UPC:
      </label>
      <div class="position-relative flex-grow-1">
        <input
          type="text"
          id="firearm_upc"
          class="form-control"
          formControlName="firearm_upc"
          placeholder="Enter UPC"
        />
        <i class="fa-solid fa-barcode barcode-icon"></i>
      </div>
    </div>

    <!-- Firearm Type -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="firearm_type" class="form-label">
        <span class="text-danger me-1">*</span>Firearm Type:
      </label>
      <ng-select
        [items]="firearm_types"
        [multiple]="false"
        [closeOnSelect]="true"
        appendTo="body"
        class="form-control flex-grow-1"
        formControlName="firearm_type"
        id="firearm_type"
        placeholder="Select type"
      ></ng-select>
    </div>

    <!-- Manufacture -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="manufacture" class="form-label">
        <span class="text-danger me-1">*</span>Manufacture:
      </label>
      <input
        type="text"
        id="manufacture"
        class="form-control flex-grow-1"
        formControlName="manufacture"
        placeholder="Enter manufacturer"
      />
    </div>

    <!-- Importer -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="importer" class="form-label">Importer:</label>
      <input
        type="text"
        id="importer"
        class="form-control flex-grow-1"
        formControlName="importer"
        placeholder="Enter importer (optional)"
      />
    </div>

    <!-- Model -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="model" class="form-label">
        <span class="text-danger me-1">*</span>Model:
      </label>
      <input
        type="text"
        id="model"
        class="form-control flex-grow-1"
        formControlName="model"
        placeholder="Enter model"
      />
    </div>

    <!-- Additional Markings -->
    <div class="form-group d-flex align-items-center mb-3">
      <label for="additional_markings" class="form-label"
        >Additional Markings:</label
      >
      <input
        type="text"
        id="additional_markings"
        class="form-control flex-grow-1"
        formControlName="additional_markings"
        placeholder="Enter additional markings (optional)"
      />
    </div>

    <!-- Caliber / Gauge -->
    <div class="form-group d-flex align-items-center mb-4">
      <label for="caliber_gauge" class="form-label">
        <span class="text-danger me-1">*</span>Caliber / Gauge:
      </label>
      <input
        type="text"
        id="caliber_gauge"
        class="form-control flex-grow-1"
        formControlName="caliber_gauge"
        placeholder="Enter caliber or gauge"
      />
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="required-indicator me-auto">
    <span class="text-danger">*</span> <span style="margin-left: 5px;">Denotes required fields</span>
  </div>
  
  <button
    type="submit"
    class="btn modern-btn primary-btn"
    style="min-width: 180px"
    [disabled]="add_edit_firearm_form.invalid || !add_edit_firearm_form.dirty"
    (click)="addEditFirearmClick()"
  >
    @if (modal_type === "Add") {
      Add Firearm
    }
    @if (modal_type === "Edit") {
      Save Changes
    }
  </button>
  <button
    type="button"
    class="btn modern-btn secondary-btn"
    (click)="closeModalClick()"
  >
    Cancel
  </button>
</div>
